import { isArray, isEmpty, isString } from 'mc-ui-utils';
export const isStory = (payload) => !isEmpty(payload) &&
    isString(payload.id) &&
    !isEmpty(payload.id) &&
    isArray(payload.glances);
export const isPreferenceScreen = (payload) => payload.isPreferenceScreen &&
    Object.keys(payload).length === 1;
//# sourceMappingURL=typegaurds.js.map